import { Link } from "@tanstack/react-router";
import { useState } from "react";

import { useGrows } from "@/lib/api/grows";
import { Button } from "@/components/ui/button";
import { ErrorState } from "@/components/error-state";

export function GrowsListPage() {
  const [includeArchived, setIncludeArchived] = useState(false);
  const q = useGrows({ include_archived: includeArchived });

  return (
    <div className="space-y-4">
      <header className="flex items-center justify-between">
        <h1 className="text-2xl font-semibold tracking-tight">Grows</h1>
        <div className="flex items-center gap-2">
          <label className="flex items-center gap-1 text-xs text-muted-foreground">
            <input
              type="checkbox"
              checked={includeArchived}
              onChange={(e) => setIncludeArchived(e.target.checked)}
            />
            include archived
          </label>
          <Link to="/grows/new">
            <Button>New grow</Button>
          </Link>
        </div>
      </header>

      {q.error && <ErrorState error={q.error} retry={q.refetch} />}
      {q.isLoading && (
        <p className="text-sm text-muted-foreground">Loading grows…</p>
      )}

      {q.data && q.data.items.length === 0 && (
        <p className="text-sm text-muted-foreground">
          No grows yet. <Link to="/grows/new" className="underline">Create your first one</Link>.
        </p>
      )}

      <ul className="divide-y rounded-md border">
        {q.data?.items.map((g) => (
          <li key={g.id}>
            <Link
              to="/grows/$growId"
              params={{ growId: g.id }}
              className="block px-4 py-3 hover:bg-accent/50"
            >
              <div className="flex items-baseline justify-between gap-4">
                <div className="space-y-0.5">
                  <p className="font-medium">{g.species}</p>
                  <p className="text-xs text-muted-foreground">
                    {g.system_type} · {g.count} plant{g.count === 1 ? "" : "s"}
                    {g.archived_at && " · archived"}
                  </p>
                </div>
                <p className="text-xs text-muted-foreground capitalize">
                  {g.current_state}
                </p>
              </div>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
